module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiB2ZXJzaW9uPSIxIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGZpbGw9IiMyOTgwYjkiIGQ9Ik0wIDBoMTI4djEyOEgweiIvPjxwYXRoIGZpbGw9InVuZGVmaW5lZCIgZD0iTTEyOCAwdjEyOEgwTDEyOCAweiIvPjx0ZXh0IGZpbGw9IiNGRkZGRkYiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSI2NCI+PHRzcGFuIHg9IjI0IiB5PSI4NSI+UEw8L3RzcGFuPjwvdGV4dD48L2c+PC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/language-icons/icons/pl.svg
// module id = fQiR
// module chunks = 1